import { render, staticRenderFns } from "./SubAddOns.vue?vue&type=template&id=0811be38"
import script from "./SubAddOns.vue?vue&type=script&lang=ts"
export * from "./SubAddOns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports